import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import alb from 'services/api/alb';
import { queryClient } from 'services/queryClient/queryClient';
import { QueryTypeModule } from 'services/queryClient/wrapperHooks/genericTables/useGetCheckTableDataWithFilters';

import { IPlanningTableBody } from '../types/planningTable.type';
import { planningTableMessagesToast } from '../variables/planningTableMessagesToast';

export const useUpdatePlanningTable = (
	module: QueryTypeModule,
	onSuccess?: () => void
) => {
	const toast = useToast();

	return useMutation({
		mutationFn: async (body: IPlanningTableBody) => {
			if (body.data.length === 0) {
				return;
			}
			return await alb.put(`/${module}/editable-view`, body);
		},
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}
			toast({
				title: planningTableMessagesToast
					.MSG_PLANNING_TABLE_UPDATED_SUCCESS.title,
				status: planningTableMessagesToast
					.MSG_PLANNING_TABLE_UPDATED_SUCCESS.status,
				duration: 3000,
				position: 'bottom-left',
				isClosable: true,
			});
			queryClient.invalidateQueries({ queryKey: [`${module}-list`] });
			queryClient.invalidateQueries({
				queryKey: [`is-status-editable`, module],
			});
		},
		onError: () => {
			toast({
				title: planningTableMessagesToast
					.MSG_PLANNING_TABLE_UPDATED_ERROR.title,
				status: planningTableMessagesToast
					.MSG_PLANNING_TABLE_UPDATED_ERROR.status,
				duration: 3000,
				position: 'bottom-left',
				isClosable: false,
			});
		},
	});
};
